import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import globals from '../globals'
import AccountOverview from '../modules/AccountOverview'
import SubNavigation from '../modules/SubNavigation'
import Invoices from '../modules/Invoices'
import PayAccount from '../modules/PayAccount'
import PaymentMethod from '../modules/PaymentMethod'
import Transactions from '../modules/Transactions'

class PaymentAndInvoices extends React.Component {
    constructor (props) {
        super(props)

        this.subNav = [
            { title: 'Account overview', url: '' },
            { title: 'Pay my account now', url: '/pay-account' },
            { title: 'Update payment method', url: '/payment-method' },
            { title: 'View invoices', url: '/invoices' },
            { title: 'Account transactions', url: '/transactions' }
        ]
    }

    componentDidMount () {
        globals.animatePageIn(this.container)
    }

    render () {
	    const RenderAccountBalance = () => {
	        return (
    <AccountOverview
                    accountBalance={this.props.accountBalance}
                    customerId={this.props.customerId}
                    customerName={this.props.customerName}
                />
            )
        }

        const RenderPayAccount = () => {
            return (
                <PayAccount
                    accountBalance={this.props.accountBalance}
                />
            )
        }

        return (
            <div ref={(el) => this.container = el} style={{ opacity: 0 }}>
                <SubNavigation
                    title='Payments & invoices'
                    items={this.subNav}
                    url={this.props.match.url}
                    className='gtm-payments-manage-tab-click flex-basis-20'
                />

                <Switch>
                    <Route exact path={this.props.match.url} render={RenderAccountBalance} />
                    <Route exact path={`${this.props.match.url}/pay-account`} render={RenderPayAccount} />
                    <Route exact path={`${this.props.match.url}/invoices`} component={Invoices} />
                    <Route exact path={`${this.props.match.url}/payment-method`} component={PaymentMethod} />
                    <Route exact path={`${this.props.match.url}/transactions`} component={Transactions} />
                </Switch>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    accountBalance: state.auth.accountBalance,
    customerId: state.auth.id,
    customerName: state.auth.fullName
})

export default connect(mapStateToProps, {})(PaymentAndInvoices)



// WEBPACK FOOTER //
// ./resources/js/pages/PaymentAndInvoices.js